module.exports = __webpack_public_path__ + "static/media/bike_logo.8c91aa4e.jpg";